//音频播放
class AudioPlayer {
    // 构造函数，初始化 AudioPlayer 实例
    constructor(type = 19) {
        this.type = type;
        // AudioContext 按需创建，避免未使用时占用资源
        this.audioContext = null;
        this.gainNode = null;
        this.simNum = "";
        this.iChannelId = 0;
     
        this.bitStreamType = 1;
        this.audioSrc = "";
        this.audioStatus = 0;
        this.playerId = this.generateUUID();
        this.videoPlayer = null;
        this.prompt = "";
        this.AudioPlay = null; //从哪里传入的，是一个vue组件AudioPlay  this.audioPlayer.AudioPlay = this
    }

    // 生成 UUID 的方法
    generateUUID() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    // 生成音频源 URL 的方法
    // 音频流使用和视频相同的直播基础设施
    generateAudioSrc(simNum, iChannelId) {
        // 使用与视频相同的域名轮转策略
        var p = 0; // 音频默认使用第一组服务器
        var url_domain = "https://live" + (3 + p) + ".kingwings.cn";
        return url_domain + "/live/" + simNum + "-" + iChannelId;
    }

    // 播放音频的方法
    voice(simNum, iChannelId) {
        if (this.audioStatus!== 1) {
            this.audioStatus = 1;
            this.audioSrc = this.generateAudioSrc(simNum, iChannelId);
            this.simNum = simNum;
            this.iChannelId = iChannelId;
           
            this.bitStreamType = 1;
            if (this.AudioPlay) {
                this.AudioPlay.load();
            } else {
                console.error('AudioPlay is not initialized.');
            }
        }
    }

    // 静音音频的方法
    muted() {
        this.audioStatus = 0;
        this.simNum = "";
        this.iChannelId = 0;
        this.ip = "";
        this.port = 0;
        this.audioSrc = "";
        if (this.AudioPlay) {
            this.AudioPlay.destroy();
        } else {
            console.error('AudioPlay is not initialized.');
        }
    }

    // 发送数据的方法
    send(t) {
        if (this.AudioPlay) {
            this.AudioPlay.send(t);
        } else {
            console.error('AudioPlay is not initialized.');
        }
    }

    // 设置音量
    setVolume(volume) {
        this._volume = Math.max(0, Math.min(1, volume));
        if (this.AudioPlay) {
            this.AudioPlay.setVolume(this._volume);
        }
    }

    // 设置提示词的方法
    setPromptWord(t) {
        if (this.videoPlayer) {
            this.prompt = this.videoPlayer.setPromptWord(t);
        }
    }

    // 获取当前播放时间的方法
    getCurrentTime() {
        if (this.AudioPlay) {
            return this.AudioPlay.getCurrentTime();
        }
        console.error('AudioPlay is not initialized.');
        return null;
    }

    // 设置当前播放时间的方法
    setCurrentTime(t) {
        if (this.AudioPlay) {
            return this.AudioPlay.setCurrentTime(t);
        }
        console.error('AudioPlay is not initialized.');
        return null;
    }

    // 获取缓冲信息的方法
    getBuffered() {
        if (this.AudioPlay) {
            return this.AudioPlay.getBuffered();
        }
        console.error('AudioPlay is not initialized.');
        return null;
    }

    // 获取播放速率的方法
    getPlaybackRate() {
        if (this.AudioPlay) {
            return this.AudioPlay.getPlaybackRate();
        }
        console.error('AudioPlay is not initialized.');
        return null;
    }

    // 设置播放速率的方法
    setPlaybackRate(t) {
        if (this.AudioPlay) {
            this.AudioPlay.setPlaybackRate(t);
        } else {
            console.error('AudioPlay is not initialized.');
        }
    }

    // 获取是否暂停的方法
    getPaused() {
        if (this.AudioPlay) {
            return this.AudioPlay.getPaused();
        }
        console.error('AudioPlay is not initialized.');
        return null;
    }

    // 暂停播放的方法
    pause() {
        if (this.AudioPlay) {
            this.AudioPlay.pause();
        } else {
            console.error('AudioPlay is not initialized.');
        }
    }

    // 开始播放的方法
    play() {
        if (this.AudioPlay) {
            this.AudioPlay.play();
        } else {
            console.error('AudioPlay is not initialized.');
        }
    }

    // 设置调试模式的方法
    setDebugMode(t) {
        if (this.AudioPlay) {
            this.AudioPlay.setDebugMode(t);
        } else {
            console.error('AudioPlay is not initialized.');
        }
    }
}

export default AudioPlayer;